:host {
  display: block;
  margin-bottom: css-var(components-mb);
  padding-left: 1rem;
  padding-right: 1rem;

  @include cms-base-font;
}

.splide__sr {
  display: none;
}

@keyframes splide-loading {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(1turn);
  }
}

.splide__track--draggable {
  -webkit-touch-callout: none;
  user-select: none;
}

.splide__container {
  box-sizing: border-box;
  position: relative;
}

.splide__list {
  backface-visibility: hidden;
  display: flexbox;
  display: flex;
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
}

.splide.is-initialized:not(.is-active) .splide__list {
  display: block;
}

.splide {
  position: relative;
  visibility: hidden;
  margin: 0 auto;
  width: 100%;
}

.splide.is-initialized,
.splide.is-rendered {
  visibility: visible;
}

.splide__slide {
  backface-visibility: hidden;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  list-style-type: none !important;
  margin: 0;
  position: relative;
}

.splide__slide img {
  vertical-align: bottom;
}

.splide__track {
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.cut-single-slide,
.cut-double-slide,
.cut-triple-slide {
  width: calc(100vw / 1.5);
}

.slider-text-wrapper {
  padding: 0.75rem;
  color: var(--cms-theme-text-color);
}

.slider-text-wrapper a {
  text-decoration: underline;
  color: var(--cms-theme-text-color);

  &:hover {
    text-decoration: none;
  }
}

.splide__arrow {
  background: transparent;
  @include generateBorder('006', solid, theme-border-color);

  height: 2.375rem;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2.375rem;
  z-index: 1;
  cursor: pointer;
  display: none;
  justify-content: center;
  align-items: center;
}

.splide__arrow:hover {
  background-color: rgb(0 0 0 / 5%);
}

.splide__arrow[disabled],
.splide__arrow.disabled {
  display: none;
}

.splide__arrow--prev {
  left: -54px;
  text-decoration: none;
}

.splide__arrow--next {
  right: -54px;
  text-decoration: none;
}

.splide__pagination {
  counter-reset: pagination-num;
}

.splide__pagination__page::before {
  counter-increment: pagination-num;
  content: counter(pagination-num);
}

.cms-slider-current-page,
.cms-slider-of-pages {
  margin-right: 6px;
}

.slider-pagination {
  font-family: 'TradeGothic';
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
}

@include media-width($breakpoint-md) {
  .splide__arrow {
    display: flex;
  }

  .splide {
    width: 84%;
  }

  .cut-single-slide {
    width: calc(87vw / 1.5);
  }

  .cut-double-slide {
    width: calc(87vw / 2.5);
  }

  .cut-triple-slide {
    width: calc(87vw / 3.5);
  }
}

@include media-width($breakpoint-xl) {
  .cut-single-slide {
    width: calc(1128px / 1.5);
  }

  .cut-double-slide {
    width: calc(1128px / 2.5);
  }

  .cut-triple-slide {
    width: calc(1128px / 3.5);
  }
}
